import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { AppConfigService, loadAppConfig } from './app/core/config/app-config.service';

loadAppConfig().then((config) => {
	if (config.production) {
		enableProdMode();
	}

	injectGoogleAds(config.googleAdsConversionId);
	injectGoogleTagManager(config.googleTagContainerId, config.googleTagId);

	bootstrapApplication(AppComponent, createAppConfig()).catch((err) => console.error(err));
});

export function getApiUrl(): string {
	return new AppConfigService().config.apiUrl;
}

export function getProduction(): boolean {
	return new AppConfigService().config.production;
}

export function getDownloadFileUrl(): string {
	return new AppConfigService().config.downloadUrl;
}

export function getConfiguratorUrl(): string {
	return new AppConfigService().config.backendConfiguratorUrl;
}

export function getRegeneroUrl(): string {
	return new AppConfigService().config.regeneroBaseUrl;
}

function injectGoogleAds(conversionId: string): void {
	if (!conversionId) {
		return;
	}

	const scriptAdsLink = document.createElement('script');
	scriptAdsLink.async = true;
	scriptAdsLink.src = 'https://www.googletagmanager.com/gtag/js?id=' + conversionId;
	document.head.appendChild(scriptAdsLink);

	const googleAdsConversionIdQuoted = "'" + conversionId + "'";
	const scriptAds = document.createElement('script');
	scriptAds.innerHTML = `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', ${googleAdsConversionIdQuoted});`;
	document.head.appendChild(scriptAds);
}

function injectGoogleTagManager(containerId: string, tagId: string): void {
	if (!tagId && !containerId) {
		return;
	}

	const scriptSrc = document.createElement('script');
	scriptSrc.async = true;
	scriptSrc.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
	document.head.appendChild(scriptSrc);

	const containerIdQuoted = "'" + containerId + "'";
	const script2 = document.createElement('script');
	script2.innerHTML = `  (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', ${containerIdQuoted});`;
	document.head.appendChild(script2);

	const noscript = document.createElement('noscript');
	const iframe = document.createElement('iframe');
	iframe.setAttribute('src', 'https://www.googletagmanager.com/ns.html?id=' + containerId);
	iframe.setAttribute('height', '0');
	iframe.setAttribute('width', '0');
	iframe.setAttribute('style', 'display: none; visibility: hidden');
	noscript.appendChild(iframe);
	document.head.appendChild(noscript);
}
